import React from 'react'
import imageFile from './../../../../../apps/next-unipolrental/public/images/ecosistema_mobility.png'
import styles from './EcosistemaMobilityImage.module.sass'

interface Props {
  testoRental: string
  testoService: string
  testoGlass: string
  testoAssistance: string
  testoTech: string
  className?: string
}

const EcosistemaMobilityImage = (props: Props) => {
  const {
    testoRental = '',
    testoService = '',
    testoGlass = '',
    testoAssistance = '',
    testoTech = '',
    className = '',
  } = props

  return (
    <div className={`${styles.root} ${className}`}>
      {imageFile?.src && <img src={imageFile?.src} className={styles.image} />}
      <p className={`${styles.testo} ${styles['testo--rental']}`}>{testoRental}</p>
      <p className={`${styles.testo} ${styles['testo--service']}`}>{testoService}</p>
      <p className={`${styles.testo} ${styles['testo--glass']}`}>{testoGlass}</p>
      <p className={`${styles.testo} ${styles['testo--assistance']}`}>{testoAssistance}</p>
      <p className={`${styles.testo} ${styles['testo--tech']}`}>{testoTech}</p>
    </div>
  )
}

export default EcosistemaMobilityImage
